import HomePage from "./Components/HomePage/HomePage";
import InputPage from "./Components/InputPage/InputPage";
import {Route, Routes} from "react-router-dom";
import {BrowserRouter as Router} from 'react-router-dom';
import CountPage from "./Components/CountPage";

function App() {



    return (

            <Router>
                <Routes>
                    <Route path="/:id" element={<HomePage/>}/>
                    <Route path="/:id/file" element={<InputPage/>}/>
                    <Route path="/:id/count" element={<CountPage/>}/>
                </Routes>
            </Router>

    );
}

export default App;
